import React from "react";
import "./style.scss";
import "./mobile.scss";

import { RiCheckLine } from "react-icons/ri";

const Index = (props) => (
  <>
    <div
      className={`wizard-no-wrapper mobile__timeline-item-wrapper d-flex align-items-center  ${props.timelineType}  ${
        props.option
      } 
         ${props.done ? "im-done" : props.isFocusTab ? "active-me" : ""}`}
    >
      <div className={"out-side-circle "}>
        <div className={"inside-circle "}>
          {!props.done && <>{props.itemNo}</>}
          {props.done && <RiCheckLine />}
        </div>
      </div>

      <div className={"text-wrapper d-flex flex-column align-items-start "}>
        <div className={"step text-center"}>{props.step}</div>
        <div className={"current-form-name"}>{props.formName}</div>
      </div>
    </div>
  </>
);
export default Index;
